import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useToast } from './Toast';

function ConfirmacionCondicional() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const { dataToSave, pendingItems, isConditional, offlineInfo } = location.state || {};
  const [isSaving, setIsSaving] = useState(false);

  const handleConfirmSave = useCallback(async () => {
    if (!dataToSave) {
      toast.error("No se encontraron datos para guardar.");
      return navigate('/');
    }
    setIsSaving(true);

    try {
      if (dataToSave.guardadoOffline === true) {
        const pendingChecklists = JSON.parse(localStorage.getItem('pendingChecklists') || '[]');
        const offlineData = { ...dataToSave, id: `offline_${Date.now()}` };
        pendingChecklists.push(offlineData);
        localStorage.setItem('pendingChecklists', JSON.stringify(pendingChecklists));

        if (offlineInfo) toast.warning(offlineInfo);
        else toast.success("Checklist guardado en el dispositivo.");
      } else {
        const finalData = { ...dataToSave, fecha: serverTimestamp() };
        await addDoc(collection(db, "checklistLivianos"), finalData);
        toast.success("Checklist guardado correctamente.");
      }

      const targetRoute = isConditional ? '/check-condicional' : '/check-realizado';
      navigate(targetRoute, {
        state: { dominio: dataToSave.dominio, fecha: new Date().toLocaleString('es-AR') }
      });
    } catch (error) {
      console.error("Error al guardar:", error);
      toast.error("Error al guardar el checklist. Revisá la consola.");
      setIsSaving(false);
    }
  }, [dataToSave, isConditional, navigate, offlineInfo, toast]);

  useEffect(() => {
    if (isConditional === false) {
      handleConfirmSave();
    }
  }, [isConditional, handleConfirmSave]);

  if (isConditional === false) {
    return (
      <div className="loading-screen">
        <div className="spinner spinner-lg"></div>
        <span>{dataToSave?.guardadoOffline ? 'Guardando en el dispositivo...' : 'Guardando checklist...'}</span>
      </div>
    );
  }

  return (
    <div className="confirm-page">
      <div className="card confirm-card">
        <div className="card-body">
          <div className="confirm-icon" aria-hidden="true">⚠</div>
          <span className="sr-only">Atención</span>
          <h1 className="confirm-title warning">Confirmación Requerida</h1>
          <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-md)' }}>
            El checklist para <strong>{dataToSave?.dominio}</strong> se guardará como <strong>Condicional</strong>:
          </p>
          <ul className="confirm-list">
            {pendingItems?.map(item => (
              <li key={item.id}>{item.label}</li>
            ))}
          </ul>
          <div className="confirm-buttons">
            <button onClick={() => navigate('/')} disabled={isSaving} className="btn btn-outline">
              Cancelar
            </button>
            <button onClick={handleConfirmSave} disabled={isSaving} className="btn btn-warning">
              {isSaving ? 'Guardando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmacionCondicional;
